import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import ProductOverview from "./components/ProductOverview";
import StorySection from "./components/StorySection";
import FeaturesSection from "./components/FeaturesSection";
import ReviewsSection from "./components/ReviewsSection";
import InstagramSection from "./components/InstagramSection";
import CTASection from "./components/CTASection";
import Footer from "@/components/feature/Footer";

export default function Home() {
  return (
    <main className="w-full min-h-screen">
      <Navbar />
      <HeroSection />
      <ProductOverview />
      <StorySection />
      <FeaturesSection />
      <ReviewsSection />
      <InstagramSection />
      <CTASection />
      <Footer />
    </main>
  );
}